import { Injectable }  from '@angular/core';
import { Address, ShoppingCart } from 'app/models';

@Injectable()
export class TicketAddressService {

	public syncTicketAddressesByShoppingcart(shoppingcart: ShoppingCart, ticketAddresses: Record<string, Address>): Record<string, Address> {
		const ticketItemUuids = shoppingcart.ticketItems.map(ticketItem => ticketItem.uuid);
		const addressTicketItemUuids = Object.keys(ticketAddresses);

		const missingAddressticketItemUuids = addressTicketItemUuids.filter(uuid => ticketItemUuids.indexOf(uuid) === -1);
		missingAddressticketItemUuids.forEach(uuid => {
			delete ticketAddresses[uuid];
		});

		return ticketAddresses;
	};
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/ticket-address/reducer/ticket-address.service.ts